import { render, staticRenderFns } from "./SigningForm.vue?vue&type=template&id=33530310&"
import script from "./SigningForm.vue?vue&type=script&lang=ts&"
export * from "./SigningForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports